import { DocumentProcessStatus } from './enums/documentProcessStatusEnum';
import { ApiDocumentProcessToModel } from "./api-document-processs-to.model";
import { ConstancyType } from './enums/constancyType';

export class ApiDocumentProcessModel {
    documentId: number;
    documentProcessId: number;
    documentProcessDescription: string;
    documentProcessName: string;
    documentHash: string;
    documentName: string;
    documentProcessUpdateDate: string;
    documentProcessCreateDate: string="";
    documentProcessStatus: DocumentProcessStatus;
    documentProcessTos: ApiDocumentProcessToModel[];
    documentFileDescriptorId: string;
    documentUploadDate: string;
    signer: string;
    signedDate: string;
    constancyNumber: string;
    constancyType: ConstancyType;
    registrationNumber: string;
    isSignatory:boolean;
    isAbleToDownloadFile:boolean;
    documentSignatureInProgress:boolean;
    
}